import { I18n } from '@calendly/i18n';
import { TimezoneIcon } from '@calendly/ui/components/icons';
import { Item } from '@calendly/ui/components/menu';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { snakeize } from 'services/string_utils';
const iconWrapperCss = "ia3hi66";
const IconWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconWrapperCss, props.className)} />;
});
export const ChangeLanguageItem = ({
  eventType,
  onClick,
  overrideDisabled = false,
  textOverride
}) => {
  const {
    locale,
    available_locales: availableLocales,
    has_events: hasEvents,
    is_group: isGroup
  } = snakeize(eventType);
  const localeTitle = availableLocales.find(({
    identifier
  }) => locale === identifier).title;
  const disabled = hasEvents && isGroup && !overrideDisabled;
  const buttonText = textOverride || I18n.t('publisher.event_type_editor.header.settings.invitee_language.change_language');
  return <Item onClick={onClick} disabled={disabled}>
      <IconWrapper>
        <TimezoneIcon />
      </IconWrapper>
      <div>
        {buttonText}
        <BodyText size="medium" color="muted">{localeTitle}</BodyText>
      </div>
    </Item>;
};

require("./change_language_item.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./change_language_item.js");